module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-PattAndLilySymbol-1280.f7981698.jpg";